'use strict';
require('../../../modules/es.array.slice');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'slice');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/slice.js
// module id = 564
// module chunks = 13